import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ApproveFundingRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const approveFundingRequest = createAsyncThunk<void, ApproveFundingRequestBody, { extra: Partial<Dependencies> }>(
  "fundingRequests/approveFundingRequest",
  async (fundingRequest: ApproveFundingRequestBody, { extra: { adminRepository } }) => {
    return adminRepository!.approve(fundingRequest);
  },
);

export const resetApproveFundingRequest = createAction("fundingRequests/resetApproveFundingRequest");
